import * as React from 'react';

import SubjectAreaSection from '../shared/subject_area_section';
import DemoGuardedButton from '../../shared/demoGuardedButton';

const TeacherSubjectAreas = ({ activateSection, active, deactivateSection, passedSelectedSubjectAreaIds, subjectAreas, updateTeacherInfo, }) => {
  const [selectedSubjectAreaIds, setSelectedSubjectAreaIds] = React.useState(passedSelectedSubjectAreaIds || [])

  React.useEffect(() => {
    if (active) { return }

    reset()
  }, [active])

  React.useEffect(reset, [passedSelectedSubjectAreaIds])

  function reset() {
    setSelectedSubjectAreaIds(passedSelectedSubjectAreaIds)
  }

  function resetAndDeactivateSection() {
    reset()
    deactivateSection()
  }

  function handleSubmit(e) {
    e?.preventDefault()
    const data = {
      subject_area_ids: selectedSubjectAreaIds,
    };
    updateTeacherInfo(data, 'Settings saved')
  }

  function renderButtonSection() {
    if (!active) { return }

    const submitButtonClassName = "quill-button contained medium green focus-on-light"

    let submitButton = <input aria-label="Save changes" className={`${submitButtonClassName} disabled`} disabled type="submit" value="Save changes" />

    if (selectedSubjectAreaIds.length) {
      submitButton = <DemoGuardedButton className={submitButtonClassName} onClick={handleSubmit}>Save changes</DemoGuardedButton>
    }

    return (
      <div className="button-section">
        <button className="quill-button outlined medium grey focus-on-light" id="cancel" onClick={resetAndDeactivateSection} type="button">Cancel</button>
        {submitButton}
      </div>
    )
  }

  return (
    <section aria-labelledby="subjectAreasTitle" className="user-account-section subject-area-section">
      <h1 id="subjectAreasTitle">Subject Areas</h1>
      <form acceptCharset="UTF-8" onSubmit={handleSubmit} >
        <div className="fields" onClick={activateSection} onKeyDown={activateSection}>
          <SubjectAreaSection
            selectedSubjectAreaIds={selectedSubjectAreaIds}
            setSelectedSubjectAreaIds={setSelectedSubjectAreaIds}
            subjectAreas={subjectAreas}
          />
        </div>
      </form>
      {renderButtonSection()}
    </section>
  )
}

export default TeacherSubjectAreas
